import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.tabs`;

export const INIT = `${SCOPE}/INIT`;
export const CHANGE_TABS = `${SCOPE}/CHANGE_TABS`;

export const ADD_TAB = `${SCOPE}/ADD_TAB`;
export const UPDATE_TAB = `${SCOPE}/UPDATE_TAB`;
export const REMOVE_TAB = `${SCOPE}/REMOVE_TAB`;
export const REPLACE_TAB = `${SCOPE}/REPLACE_TAB`;
export const REMOVE_BACKGROUND_TAB = `${SCOPE}/REMOVE_BACKGROUND_TAB`;

export const TRIGGER_CHANGE_TABS = `${SCOPE}/TRIGGER_CHANGE_TABS`;
export const TRIGGER_ADD_TAB = `${SCOPE}/TRIGGER_ADD_TAB`;
export const TRIGGER_UPDATE_TAB = `${SCOPE}/TRIGGER_UPDATE_TAB`;
export const TRIGGER_REMOVE_TAB = `${SCOPE}/TRIGGER_REMOVE_TAB`;
export const TRIGGER_REPLACE_TAB = `${SCOPE}/TRIGGER_REPLACE_TAB`;

